import { Avatar, Card, CardContent, CircularProgress, Divider, List, ListItem, ListItemAvatar, ListItemText, MenuItem, TextField, Typography } from "@mui/material";
import { HealthAndSafety, ChildCare, BeachAccess, SyncAlt, Functions, NoteAdd, AccessTime, PunchClock, Celebration } from "@mui/icons-material";
import { useEffect, useState } from "react";
import axios from "axios";
import { getISOWeek, getISOWeekYear } from "date-fns";
import { Button } from "react-bootstrap";
import GetWeekNumber from "../../../../../../sharedComponents/GetWeekNumber";
import formatDuration from "../../../../../../sharedComponents/FormatDuration";
import parseDuration from "../../../../../../sharedComponents/ParseDuration";
import SchoolIcon from '@mui/icons-material/School';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

function WorktimeDashboard(props){

    function dashboardCards(){
        let index = props.allMonths.findIndex((item) => {
            let arrayDate = new Date(item.month);
            let todayDate = new Date();
            return arrayDate.getMonth() === todayDate.getMonth() && arrayDate.getFullYear() === todayDate.getFullYear();
        })
        const previousMonthObject = props.allMonths[index-1];
        const currentMonthObject = props.allMonths[index];
        const nextMonthObject = props.allMonths[index+1];
        
        return (
            <>
                {previousMonthObject !== undefined ? dashboardSingleMonthCard(previousMonthObject, true) : false}
                {dashboardSingleMonthCard(currentMonthObject, false)}
                {nextMonthObject !== undefined ? dashboardSingleMonthCard(nextMonthObject, true) : false}
            </>
            
        )
    }

    function dashboardSingleMonthCard(currentMonthObject, sideCardBoolean){
        if(currentMonthObject === undefined) return;
        const currentDate = new Date(currentMonthObject.month).toLocaleDateString('de', { month: 'long', year: 'numeric' })
        let cardHeaderAddOn = sideCardBoolean ? "" : "(aktueller Monat)"
        const sideCardResultBoolean = (sideCardBoolean && currentMonthObject.result === null)
        const illnessTime = formatDuration(parseDuration(currentMonthObject.total_payed_absence_duration_by_type?.illness));
        const childSickTime = formatDuration(parseDuration(currentMonthObject.total_payed_absence_duration_by_type?.child_sick));
        const vacationTime = formatDuration(parseDuration(currentMonthObject.total_payed_absence_duration_by_type?.vacation));
        const paidHoliday = formatDuration(parseDuration(currentMonthObject.total_payed_absence_duration_by_type?.holiday))
        const paidSchool = formatDuration(parseDuration(currentMonthObject.total_payed_absence_duration_by_type?.school));
        const paidFurtherEducation = formatDuration(parseDuration(currentMonthObject.total_payed_absence_duration_by_type?.further_education));
        const paidVocationalSchool = formatDuration(parseDuration(currentMonthObject.total_payed_absence_duration_by_type?.vocational_school));
        const paidUniversity = formatDuration(parseDuration(currentMonthObject.total_payed_absence_duration_by_type?.university));
        const paidOther = formatDuration(parseDuration(currentMonthObject.total_payed_absence_duration_by_type?.other));

        return (
            <Card sx={{ minWidth: 400, maxWidth: 400, backgroundColor: '#f5f5f5', transform: sideCardBoolean ? 'scale(0.9)' : false }}>
                <CardContent>
                    <div className="card-header">
                        <Typography variant="h5">{currentDate}</Typography>
                        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>{cardHeaderAddOn}</Typography>
                    </div>                    
                    <Divider/>
                    <List>
                        {props.transferhoursBoolean && <ListItem secondaryAction={<ListItemText primary={formatDuration(parseDuration(currentMonthObject.transfer_from_last_month))} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <SyncAlt fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Transfer: "}/>
                        </ListItem>}
                        <ListItem secondaryAction={<ListItemText primary={formatDuration(parseDuration(currentMonthObject.target_working_hours))} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <AccessTime fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Soll-Zeit: "}/>
                        </ListItem>
                        <ListItem secondaryAction={<ListItemText primary={formatDuration(parseDuration(currentMonthObject.total_tracked_shifts_duration))} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <PunchClock fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"aufgezeichnete Stunden: "} primaryTypographyProps={{style: {width: "100px"}}}/>
                        </ListItem>

                        {illnessTime !== "00:00 Std" && <ListItem secondaryAction={<ListItemText primary={illnessTime} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <HealthAndSafety fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Krankenstunden: "} />
                        </ListItem>}

                        {childSickTime !== "00:00 Std" && <ListItem secondaryAction={<ListItemText primary={childSickTime} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <ChildCare fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Kindkrankstunden: "} />
                        </ListItem>}

                        {vacationTime !== "00:00 Std" && <ListItem secondaryAction={<ListItemText primary={vacationTime} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <BeachAccess fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Urlaubsstunden: "} />
                        </ListItem>}

                        {paidHoliday !== "00:00 Std" && <ListItem key="paidHoliday" secondaryAction={<ListItemText primary={paidHoliday} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <Celebration fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Feiertagsstunden: "} />
                        </ListItem>}

                        {paidSchool !== "00:00 Std" && <ListItem key="paidSchool" secondaryAction={<ListItemText primary={paidSchool} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <SchoolIcon fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Schulstunden: "} />
                        </ListItem>}

                        {paidFurtherEducation !== "00:00 Std" && <ListItem key="paidFurtherEducation" secondaryAction={<ListItemText primary={paidFurtherEducation} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <LightbulbIcon fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Weiterbildung: "} />
                        </ListItem>}

                        {paidVocationalSchool !== "00:00 Std" && <ListItem key="paidVocationalSchool" secondaryAction={<ListItemText primary={paidVocationalSchool} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <SchoolIcon fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Berufsschule: "} />
                        </ListItem>}

                        {paidUniversity !== "00:00 Std" && <ListItem key="paidUniversity" secondaryAction={<ListItemText primary={paidUniversity} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <SchoolIcon fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Universität: "} />
                        </ListItem>}

                        {paidOther !== "00:00 Std" && <ListItem key="paidOther" secondaryAction={<ListItemText primary={paidOther} />}>
                            <ListItemAvatar>
                                <Avatar>
                                <MoreHorizIcon fontSize="small" />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Sonstigestunden: "} />
                        </ListItem>}

                        <ListItem secondaryAction={                  
                            <ListItemText primary={formatDuration(parseDuration(currentMonthObject.total_sum_of_corrections))} />                        
                        }>
                            <ListItemAvatar>
                                <Avatar>
                                <NoteAdd fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Korrekturstunden: "}/>
                        </ListItem>

                        <Divider/>
                        <ListItem secondaryAction={<ListItemText primary={sideCardResultBoolean ? "Noch nicht verfügbar" : formatDuration(parseDuration(currentMonthObject.result))} primaryTypographyProps={{style:{fontWeight: sideCardResultBoolean ? 'normal' : 'bold', fontStyle: sideCardResultBoolean ? 'italic' : 'normal', fontSize: '20px', color: 'black'}}}/>}>
                            <ListItemAvatar>
                                <Avatar>
                                <Functions fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bilanz: "} primaryTypographyProps={{style:{fontWeight: 'bold', fontSize: '20px'}}} />
                        </ListItem>
                    </List>
                </CardContent>
            </Card>
        )
    }

    return(
        <>{dashboardCards()}</>
    )
} 

export function WorktimeWeekDashboard(props){
    const [selectedWeek, setSelectedWeek] = useState(GetWeekNumber(new Date()));
    const [selectedYear, setSelectedYear] = useState(getISOWeekYear(new Date()));
    const [weekData, setWeekData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loadError, setLoadError] = useState(false);

    const getIsoWeeksInYear = (year) => getISOWeek(new Date(year, 11, 28)) === 53 ? 53 : 52;

    const handleYearChange = (event) => {
        const year = Number(event.target.value);
        setSelectedYear(year);
        if (selectedWeek > getIsoWeeksInYear(year)) {
            setSelectedWeek(getIsoWeeksInYear(year));
        }
    };

    useEffect(() => {
        let cancelled = false;
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("jwtToken");
        setIsLoading(true);
        setLoadError(false);

        axios.get('workingTimeAccount/weeklyOverview', {
            params: {
                employeeId: props.employeeId,
                year: selectedYear,
                week: selectedWeek
            }
        }).then(results => {
            if(!cancelled){
                setWeekData(results.data);
                setIsLoading(false);
            }
        }).catch(() => {
            if(!cancelled){
                setLoadError(true);
                setIsLoading(false);
            }
        });

        return () => { cancelled = true; };
    }, [props.employeeId, props.weeklyTargetHours, selectedWeek, selectedYear]);

    const years = Array.from(new Set([
        selectedYear,
        getISOWeekYear(new Date()),
        ...(props.allMonths || []).map(item => parseInt(item.month.substring(0, 4), 10))
    ])).filter(year => !isNaN(year)).sort((a, b) => a - b);

    function formatGermanDate(dateString){
        if(!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return day + "." + month + "." + year;
    }

    function weekCard(){
        const weeklyTarget = weekData?.weekly_target_hours;
        const weeklyBalance = weekData?.weekly_balance;
        const actualHours = weekData?.tracked_actual_hours ?? "PT0H";
        const paidHoliday = weekData?.paid_holiday_hours ?? "PT0H";
        const correctionHours = weekData?.correction_hours ?? "PT0H";

        return (
            <Card sx={{ width: '100%', maxWidth: 400, backgroundColor: '#f5f5f5' }}>
                <CardContent>
                    <div className="card-header">
                        <Typography variant="h5">KW {weekData.iso_week} / {weekData.iso_year}</Typography>
                        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
                            {formatGermanDate(weekData.monday)} – {formatGermanDate(weekData.sunday)}
                        </Typography>
                    </div>
                    <Divider/>
                    <List>
                        <ListItem secondaryAction={<ListItemText primary={weeklyTarget ? formatDuration(parseDuration(weeklyTarget)) : "Noch nicht verfügbar"} primaryTypographyProps={weeklyTarget ? {} : {style: {fontStyle: 'italic'}}}/>}>
                            <ListItemAvatar>
                                <Avatar>
                                    <AccessTime fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Wochensoll: "}/>
                        </ListItem>

                        <ListItem secondaryAction={<ListItemText primary={formatDuration(parseDuration(actualHours))}/>}>
                            <ListItemAvatar>
                                <Avatar>
                                    <PunchClock fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Ist-Stunden Montag–Sonntag: "}/>
                        </ListItem>

                        {formatDuration(parseDuration(paidHoliday)) !== "00:00 Std" && <ListItem secondaryAction={<ListItemText primary={formatDuration(parseDuration(paidHoliday))}/>}>
                            <ListItemAvatar>
                                <Avatar>
                                    <Celebration fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Bezahlte Feiertagsstunden: "}/>
                        </ListItem>}

                        {formatDuration(parseDuration(correctionHours)) !== "00:00 Std" && <ListItem secondaryAction={<ListItemText primary={formatDuration(parseDuration(correctionHours))}/>}>
                            <ListItemAvatar>
                                <Avatar>
                                    <NoteAdd fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Korrekturstunden: "}/>
                        </ListItem>}

                        <Divider/>
                        <ListItem secondaryAction={<ListItemText primary={weeklyBalance ? formatDuration(parseDuration(weeklyBalance)) : "Noch nicht verfügbar"} primaryTypographyProps={{style: {fontWeight: weeklyBalance ? 'bold' : 'normal', fontStyle: weeklyBalance ? 'normal' : 'italic', fontSize: '20px', color: 'black'}}}/>}>
                            <ListItemAvatar>
                                <Avatar>
                                    <Functions fontSize="small"/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={"Wochenbilanz: "} primaryTypographyProps={{style: {fontWeight: 'bold', fontSize: '20px'}}}/>
                        </ListItem>
                    </List>
                </CardContent>
            </Card>
        )
    }

    return (
        <div className="weekly-dashboard">
            <div className="weekly-dashboard-controls">
                <TextField
                    select
                    size="small"
                    label="Kalenderwoche"
                    value={selectedWeek}
                    onChange={(event) => setSelectedWeek(Number(event.target.value))}
                    sx={{ minWidth: 150 }}
                >
                    {Array.from({ length: getIsoWeeksInYear(selectedYear) }, (_, index) => index + 1).map(week => (
                        <MenuItem key={week} value={week}>KW {week}</MenuItem>
                    ))}
                </TextField>
                <TextField
                    select
                    size="small"
                    label="Jahr"
                    value={selectedYear}
                    onChange={handleYearChange}
                    sx={{ minWidth: 110 }}
                >
                    {years.map(year => (
                        <MenuItem key={year} value={year}>{year}</MenuItem>
                    ))}
                </TextField>
                <Button variant="dark" onClick={props.onChangeWeeklyTarget} style={{ backgroundColor: 'var(--tictrack-secondary-color)' }}>Wochensoll ändern</Button>
            </div>
            {isLoading ? <CircularProgress/> :
                loadError ? <Typography>Die Wochenansicht konnte nicht geladen werden.</Typography> :
                weekData && weekCard()}
        </div>
    )
}

export default WorktimeDashboard;